export enum StationRouteWaypointAddMode {
  None = "None",
  Search = "Search",
  MapClick = "MapClick",
}
